module.exports = __webpack_public_path__ + "img/commissionSum.43137afc.svg";